export default __webpack_public_path__ + "static/solo.coder_podcast-24dbeed796ad6f5c7a5be177e425fcd0.jpeg";